import React, { useEffect, useRef } from "react";
import styles from "./palaciodas_delicias.module.scss";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import FoodMenuIcon from "../../icons/foodMenuIcon.tsx";
import PalaciodasDeliciasButton from "./palaciodas_delicias_button.tsx";

const links = [
  {
    title: "Instagram",
    href: "https://www.instagram.com/palaciodas_delicias?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    icon: <InstagramIcon color="#fffdf8" height="24" />,
  },
  {
    title: "WhatsApp - Bolos",
    href: "https://wa.me/5517981129654?text=Olá, vim pelo link na bio e gostaria de mais informações...",
    icon: <WhatsappIcon color="#fffdf8" height="30" />,
  },
  {
    title: "Localização",
    href: "https://maps.app.goo.gl/d1exhBeWg2Hn9A338",
    icon: <MapsIcon color="#fffdf8" height="32" />,
  },
  {
    title: "Catálogo - Roscas",
    href: "/palaciodas_delicias/roscas",
    icon: <FoodMenuIcon color="#fffdf8" height="26" />,
    isLink: true,
  },
];

const bolos = [
  { src: require("./src/bolo1.png"), alt: "Bolo 1" },
  { src: require("./src/bolo2.png"), alt: "Bolo 2" },
  { src: require("./src/bolo3.png"), alt: "Bolo 3" },
  { src: require("./src/bolo4.png"), alt: "Bolo 4" },
];

const Palaciodas_delicias: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const handleVisibility = () => {
      track.style.animationPlayState = document.hidden ? "paused" : "running";
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  return (
    <div className={styles.palaciodas_delicias}>
      <div className={styles["body-thunder"]}>

        {/* ── Carrossel infinito como header ── */}
        <div className={styles["carousel-section"]}>
          <div className={styles["carousel-track"]} ref={trackRef}>
            {[...bolos, ...bolos].map((bolo, i) => (
              <img key={i} src={bolo.src} alt={bolo.alt} className={styles["carousel-img"]} />
            ))}
          </div>
          <div className={styles["carousel-fade"]} />
        </div>

        <div className={styles["container-thunder"]}>

          {/* ── Logo sobreposta: metade no carrossel, metade fora ── */}
          <div className={styles["img-perfil"]}>
            <img src={require("./src/perfil.png")} alt="Logo Palácio das Delícias" />
          </div>

          <h1>Palácio das Delícias</h1>
          <p className={styles.subtitle}>Confeitaria Artesanal</p>

          <div className={styles.divider}>
            <div className={styles.diamond} />
          </div>

          <div className={styles.links}>
            {links.map(({ title, href, icon, isLink }) => (
              <PalaciodasDeliciasButton
                key={title}
                href={href}
                title={title}
                icon={icon}
                isInternal={isLink}
              />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Palaciodas_delicias;
